import axiosInstance from "../../../Utils/axiosInstance";

export const partnerApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/sourcing_management/getPartners?status=" + payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getPartnerByIdApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/sourcing_management/getPartnerByID?Partner_ID=" + payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
export const getPartnerOverviewApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/sourcing_management/getOverview?Partner_ID=" + payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getBankingApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/sourcing_management/getBankingAndOperation?Partner_ID=" +
                payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getFileAndUploadApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/sourcing_management/getFileAndUpload?Partner_ID=" + payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

interface Payload {
    partnerId: string;
    partnerName: string;
    partnerEmail: string;
    reason_for_rejection: string;
    userEmail: string;
    partner_status: string;
    notificationID: string;
}
export const approveAndRejectApi = async (payload: Payload[]) => {
    try {
        const response = await axiosInstance.post(
            "api/general/stakeHolderUpdateStatus",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getAllFilesDownload = async (
    payload: string,
    filename: string
) => {
    try {
        const response = await axiosInstance.get(
            `api/sourcing_management/getFilesV1?Partner_ID=${payload}`,
            { responseType: "blob" }
        );

        // Create a blob URL
        const blob = new Blob([response.data], {
            type: response.headers["content-type"]
        });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element and trigger the download
        const link = document.createElement("a");
        link.href = url;
        const contentDisposition = response.headers["content-disposition"];
        let fileName = filename;
        if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+)"/);
            if (match && match[1]) {
                fileName = match[1];
            }
        }

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return true; // Indicate successful download
    } catch (error) {
        console.error("Error fetching files:", error);
        return error?.response?.data;
    }
};

export const updateAuditStatyByQH = async (partnerID: string) => {
    try {
        const response = await axiosInstance.post(
            "api/quality_management/updateAuditStatus",
            { partnerID: partnerID }
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
